export const USER_DATA_CACHE_TIMEOUT = 24 * 60 * 60 * 1000;
export const USER_DATA_CACHE_STORAGE_KEY = 'dynamicConfigUserData';
export const CLIENT_STORAGE_KEY = 'dynamicConfigClient';
export const OVERRIDES_STORAGE_KEY = 'dynamicConfigOverrides';
